function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
//mobile facet swiper slide

const startMobileSwiper = () => {
  const mobileSwiper = document.querySelector(".swiper-facets");

  if (mobileSwiper) {
    var facetSwiper = new Swiper(".swiper-facets", {
      slidesPerView: "auto",
      spaceBetween: 10,
      breakpoints: {
        768: {
          enabled: false,
        },
      },
    });
  }
};
class ShowMore extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.show) this.showFirst = parseInt(this.dataset.show, 10);
    this.showMoreBtn = this.querySelector(".show-more-btn");
    this.ulList = this.querySelectorAll("li");
  }

  init() {
    if (this.ulList.length > this.showFirst) {
      this.hideAfterFirst(this.showFirst);

      if (this.showMoreBtn) {
        this.showMoreBtn.addEventListener("click", (event) =>
          this.handleClick(event)
        );
      }
    } else {
      if (this.showMoreBtn)
        this.showMoreBtn.closest("div").classList.add("hidden");
    }
  }
  handleClick(event) {
    event.preventDefault();
    this.showMoreBtn.closest("div").classList.add("hidden");
    for (let i = this.showFirst - 1; i < this.ulList.length; i++) {
      this.ulList[i].classList.remove("hidden");
    }
  }

  hideAfterFirst(showFirst) {
    this.ulList.forEach((ul, i) => {
      if (i > showFirst - 1) {
        ul.classList.add("hidden");
        if (this.dataset.animateCls) ul.classList.add(this.dataset.animateCls);
      }
    });
  }
}
customElements.define("show-more", ShowMore);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productCount: "#ProductCount",
      formInput: ".metal-filter-input",
      sortingFormDesktop: ".desktopSort",
      sortingFormMobile: ".mobileSort",
    };

    this.dropdown = this.querySelector("dropdown-main");
    if (this.dropdown) {
      this.handleDropdownExistence(this.dropdown);
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.debouncedOnClickFilterCount = debounce((event) => {
      this.updateFilterCount(event);
    }, 500);

    this.facetForm = this.querySelector("form");
    if (this.dataset.type == "button") {
      this.facetForm
        .querySelector(".filter-button")
        .addEventListener("click", this.debouncedOnSubmit.bind(this));

      this.facetForm.addEventListener(
        "input",
        this.debouncedOnClickFilterCount.bind(this)
      );

      this.updateFilterCount();
    }
  }
  onDropDownClick(event) {
    const selected = parseInt(event.target.dataset.index, 10);
    this.select.selectedIndex = selected;
    const sortingForm =
      window.screen.width <= 768
        ? document.querySelector(this.selectors.sortingFormMobile)
        : document.querySelector(this.selectors.sortingFormDesktop);

    const filterParam = this.createSearchParams(
      document.querySelector(".filterFacet")
    );
    const sortParam = this.createSearchParams(sortingForm);
    var url = window.location.search.slice(1);
    if (url) {
      url = this.replaceSortBy(url, sortParam);
    } else url = sortParam;
    this.submitForm(url, event);
  }

  handleDropdownExistence(dropdown) {
    this.select = this.querySelector("select");
    dropdown.effect = this.onDropDownClick.bind(this);
  }

  static setLoadingScreen(loading = true) {
    const loadingOverlay = document.querySelector(".loading-overlay");
    if (loading) {
      document.querySelector("#product-grid").classList.add("loading");
    } else {
      document.querySelector("#product-grid").classList.remove("loading");
    }
  }
  replaceSortBy(url, replacement) {
    const regex = /(sort_by=[^&]*)($|&)/;
    return url.replace(regex, replacement);
  }

  static renderPage(searchParams, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    FacetFiltersForm.setLoadingScreen();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl)
        : FacetFiltersForm.renderSectionFromFetch(url);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  static renderSectionFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderFilters(html);
        FacetFiltersForm.renderFilterAccordions(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.setLoadingScreen(false);
      });
  }

  static renderSectionFromCache(filterDataUrl) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderFilters(html);
    FacetFiltersForm.renderFilterAccordions(html);

    FacetFiltersForm.setLoadingScreen(false);
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    document.querySelector("#MobileActiveFacets").innerHTML =
      parsedHTML.querySelector("#MobileActiveFacets").innerHTML;

    startMobileSwiper();

    document.querySelector("#ActiveFacets").innerHTML =
      parsedHTML.querySelector("#ActiveFacets").innerHTML;
  }

  static renderFilterAccordions(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const filterAccordions = document.querySelector(".filterAccordions");
    filterAccordions.innerHTML =
      parsedHTML.querySelector(".filterAccordions").innerHTML;

    const closestFacetForm = filterAccordions.closest("facet-form");
    if (closestFacetForm) closestFacetForm.updateFilterCount();
  }

  static renderProductGridContainer(html) {
    document.querySelector("#product-grid").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("#product-grid").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("#ProductCount span");

    const container = document.querySelector("#ProductCount span");

    if (container && count) {
      container.innerHTML = count.innerHTML;
    }
  }
  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );

    if (event.currentTarget.dataset.name) {
      document
        .querySelector(`input[name='${event.currentTarget.dataset.name}']`)
        .removeAttribute("checked");
    }

    FacetFiltersForm.renderPage(url);
  }

  onClickHandler(event) {
    event.preventDefault();

    const sortingForm =
      window.screen.width <= 768
        ? document.querySelector(this.selectors.sortingFormMobile)
        : document.querySelector(this.selectors.sortingFormDesktop);

    const filterParam = this.createSearchParams(event.target.closest("form"));
    const sortParam = this.createSearchParams(sortingForm);
    const searchParams = filterParam + "&" + sortParam;

    this.onSubmitForm(searchParams, event);
  }

  getSortingForm() {
    return window.screen.width <= 768
      ? document.querySelector(this.selectors.sortingFormMobile)
      : document.querySelector(this.selectors.sortingFormDesktop);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortingForm = this.getSortingForm();
    const filterParam = this.createSearchParams(event.target.closest("form"));
    const sortParam = this.createSearchParams(sortingForm);
    const searchBarForm = document.querySelector(".header-search-bar form");
    var searchParams = filterParam + "&" + sortParam;
    if (searchBarForm) {
      var searchParams =
        this.createSearchParams(searchBarForm) +
        "&" +
        filterParam +
        "&" +
        sortParam;
    }

    this.submitForm(searchParams, event);
  }

  submitForm(searchParams) {
    FacetFiltersForm.renderPage(searchParams);
  }

  updateFilterCount(event) {
    const checkedInput = this.facetForm.querySelectorAll(
      `${this.selectors.formInput}:checked`
    );

    if (checkedInput.length) {
      this.facetForm.querySelector(
        ".filter-button #selected_number"
      ).innerHTML = `(${checkedInput.length})`;
    } else {
      const submitbutton = this.facetForm.querySelector(
        ".filter-button #selected_number"
      );
      if (submitbutton) submitbutton.innerHTML = "";
    }
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-form", FacetFiltersForm);
// FacetFiltersForm.setListeners();

// Facet remove

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");

    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
  }

  closeFilter(event) {
    event.preventDefault();
    const form = document.querySelector("facet-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

// for drawer codes
overlay = document.querySelector(".overlay");
document.getElementById("FilterSortButton").addEventListener("click", () => {
  document.querySelector(".filter-drawer").classList.add("open");
  overlay.classList.toggle("open");
  document.documentElement.style.overflow = "hidden";
});

const getBack = () => {
  document.querySelector(".filter-drawer").classList.remove("open");
  overlay.classList.remove("open");
  document.documentElement.style.overflow = "";
};
if (window.innerWidth <= 768) {
  document
    .querySelector(".filter-button")
    .addEventListener("click", () => getBack());
  startMobileSwiper();
}
